import {Component, OnInit, ViewContainerRef} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms'
import {DataService} from "../services/data.service";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';
import {Router} from "@angular/router";



@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  providers: [ToastsManager],
  styleUrls: ['./registration.component.scss']
})
export class RegistrationComponent implements OnInit {

  constructor(public DataService: DataService,
              public vRef: ViewContainerRef,
              public toastr: ToastsManager,
              public router: Router  ) {
    this.toastr.setRootViewContainerRef(vRef);
  }

  registrationForm: FormGroup;

  ngOnInit() {
    this.registrationForm = new FormGroup({
      'login': new FormControl(null, [Validators.required, Validators.minLength(6), Validators.pattern("^[A-Za-z]([\.A-Za-z0-9-]{1,18})([A-Za-z0-9])$")]),
      'password': new FormControl(null, [Validators.required, Validators.minLength(6)]),
      'confirmPassword': new FormControl(null, [Validators.required, this.confirmPassword.bind(this)]),
      'masterPassword': new FormControl(null, [Validators.required, Validators.minLength(4), Validators.maxLength(8)]),
      'confirmMasterPassword': new FormControl(null, [Validators.required, this.confirmMasterPassword.bind(this)]),
      'email': new FormControl(null, [Validators.required, Validators.pattern("^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$")]),
      'phone': new FormControl(null ),
      'termsConfirm': new FormControl(false)
    });
    this.registrationForm.get('password').valueChanges.subscribe(
      () =>{
        this.registrationForm.controls['confirmPassword'].updateValueAndValidity();
      }
    );
    this.registrationForm.get('masterPassword').valueChanges.subscribe(
      () =>{
        this.registrationForm.controls['confirmMasterPassword'].updateValueAndValidity();
      }
    );

   /* this.registrationForm.get('login').valueChanges.subscribe(
      (value) =>{
        console.log(this.registrationForm.get('login'))
      }
    );*/


  }

  onSubmit() {
    console.log(this.registrationForm);

    this.DataService.postLcRegistration(this.registrationForm.value)
      .subscribe(
        (data) => {
          this.toastr.success('Новий кабінет зареєстровано');
          this.router.navigate(['/login']);

          console.log(data);
        },
        (error) =>{
          this.registrationForm.controls['login'].setErrors({'alreadyinuse':true});
          this.toastr.error(error.message, error.status_code,{dismiss: 'click'});

          console.log(error);
        }
      );

  }

  onGoHome (){
    this.router.navigate(['/login']);
  }

  confirmPassword(control: FormControl): { [s: string]: boolean } {
    if (typeof (this.registrationForm) !== 'undefined') {
      if (this.registrationForm.get('password').value !== null) {
        if (this.registrationForm.get('password').value !== control.value) {
          return {'passwordIsUnconfirmed': true};
        }
      }
    }
    return null;
  }

  confirmMasterPassword(control: FormControl): { [s: string]: boolean } {
    if (typeof (this.registrationForm) !== 'undefined') {
      if (this.registrationForm.get('masterPassword').value !== null) {
        if (this.registrationForm.get('masterPassword').value !== control.value) {
          return {'masterPasswordIsUnconfirmed': true};
        }
      }
    }
    return null;
  }


}




// WEBPACK FOOTER //
// /home/backend/NasheDelo/WebLombard/client/src/app/registration/registration.component.ts